// Packages Imports
import { Space, Typography } from 'antd'

// Module Imports
import Logo from '@/modules/auth/components/logo'

const { Text } = Typography

export default function AuthHeader() {
  return (
    <Space orientation="vertical" size={4} align="center" className="w-full">
      <Logo />
      <Text className="text-center text-2xl! font-semibold">
        BilgiLig'e Hoş Geldiniz
      </Text>
      <Text type="secondary" className="text-center">
        Yönetim paneline giriş yapın
      </Text>
    </Space>
  )
}
